export function fadeOut (opts = {}) {
  return {
    opacity: 0,
    easing: 'linear',
    duration: opts.duration || 350
  }
}

export function fadeIn (opts = {}) {
  return {
    opacity: 1,
    easing: 'linear',
    duration: opts.duration || 350
  }
}
